import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ModalInfo from "views/Checkout/Modais/ModalInfo";
import InputMask from 'react-input-mask';
import { Autocomplete, TextField, FormControl } from "@mui/material";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";
import { FormMultaNaoAcompanhadaButtons } from "../FormMultaNaoAcompanhadaButtons";
import { serverApi } from "services/constante";

const faseOptions = [
  { label: "Defesa Prévia", value: "P" },
  { label: "1ª Instância", value: "I" },
  { label: "2ª Instância", value: "II" }
];

export function FormMultaNaoAcompanhadaDadosDefesa({ isActive, onFinalSubmit }) {
  const cadastroStore = useCadastroMultaNaoAcompanhadaStore();

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    
    const faseLabel = formData.get("fase");
    const faseId = faseOptions.find(option => option.label === faseLabel)?.value;
    
    const formValues = {
      fase: faseId,
    };

    cadastroStore.setDadosDefesa(formValues);
    const allFormValues = cadastroStore.getAllFormValues();
    onFinalSubmit(allFormValues);
  };

  return (
    <form onSubmit={onSubmit}>
      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo texto={"Se você recebeu a Notificação de Autuação, deverá cadastrar o recurso da sua multa para  Defesa Prévia. Caso tenha recebido a Notificação de Penalidade, deverá cadastrar o recurso para 1ª Instância. Se você já recorreu a 1ª instância e não houve êxito ao recurso, então, deverá recorrer a 2ª Instância."} label="Fase" />
          <FormControl style={{ marginTop: 26, width: "100%" }}>
            <Autocomplete
              id="Fase"
              options={faseOptions}
              getOptionLabel={(option) => option.label} // Exibe apenas os rótulos
              defaultValue={faseOptions.find(option => option.value === cadastroStore.fase)}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label="Selecione a fase" 
                  name="fase"
                  required 
                />
              )}
            />
          </FormControl>
        </GridItem>
      </GridContainer>

      <FormMultaNaoAcompanhadaButtons />
    </form>
  );
}